import React from "react";
import { LogOut, Mail, Phone, Globe, FileText, UserMinus, CalendarDays, Music } from "lucide-react";
import { Coordonnees, Securite } from "./Profil";
import { Groupe, Ligne, TitreGroupe } from "./ui";
import { MessagesEcole } from "./TabAujourdhui";

/* Profil : tout ce qui se règle une fois puis s'oublie. Les coordonnées d'abord, parce
   que c'est ce qui bloque une facture quand il manque le code postal. */
export const TabProfil = ({ moi, onRecharger, onQuitter }) => (
  <div className="space-y-6" data-testid="espace-tab-profil">
    {moi.rattachee && (
      <div data-testid="espace-profil-adresse">
        <Coordonnees moi={moi} onEnregistre={onRecharger} />
      </div>
    )}

    <Securite email={moi.email} onEmailChange={onRecharger} />

    {/* Tous les messages de l'école (envois groupés), lus ou non : l'Accueil ne garde que
        les nouveaux (20.10.2026). */}
    {(moi.messages || []).length > 0 && (
      <section data-testid="espace-profil-messages">
        <TitreGroupe>Messages de l'école</TitreGroupe>
        <MessagesEcole messages={moi.messages} tous />
      </section>
    )}

    <section>
      <TitreGroupe>Documents et démarches</TitreGroupe>
      <Groupe>
        <Ligne Icone={FileText} couleur="#0EA5E9" titre="Règlement de l'école"
          href="/reglement" testId="espace-lien-reglement" />
        <Ligne Icone={CalendarDays} couleur="#F59E0B" titre="Dates importantes"
          sousTitre="Vacances, spectacles, stages" href="/dates-importantes" testId="espace-lien-dates" />
        <Ligne Icone={UserMinus} couleur="#94A3B8" titre="Désinscription"
          sousTitre="Arrêter un cours à la fin du semestre" href="/desinscription"
          testId="espace-lien-desinscription" />
      </Groupe>
    </section>

    <section>
      <TitreGroupe>Contacter l'école</TitreGroupe>
      <Groupe>
        <Ligne Icone={Mail} couleur="#00C6CE" titre="Écrire un e-mail" sousTitre="info1000arts@gmail.com"
          href="mailto:info1000arts@gmail.com" testId="espace-contact-email" />
        <Ligne Icone={Phone} couleur="#16A34A" titre="Appeler — danse" sousTitre="079 950 40 31"
          href="tel:+41799504031" testId="espace-contact-tel" />
        <Ligne Icone={Music} couleur="#9333EA" titre="Appeler — comédie musicale" sousTitre="079 436 89 39"
          href="tel:+41794368939" testId="espace-contact-tel-comedie" />
        <Ligne Icone={Globe} couleur="#0F1B2D" titre="Le site 1000arts.ch" href="/" testId="espace-contact-site" />
      </Groupe>
    </section>

    <Groupe>
      <Ligne Icone={LogOut} couleur="#DC2626" titre="Me déconnecter" danger fleche={false}
        onClick={onQuitter} testId="espace-quitter" />
    </Groupe>

    <p className="text-[12px] text-[var(--muted)] text-center px-4">
      Une information fausse ou manquante ? Corrige-la ici, ou écris-nous : l'école voit
      chaque modification.
    </p>
  </div>
);
